import React from 'react';
import { BodyText, Button, WarningIcon } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { Message } from '@paypalcorp/worldready-react';

const GenericInternalServiceError = ({ handleRetry, id }) => {
  return (
    <div className="generic-service-error" data-testid="generic-service-error">
      <WarningIcon
        size="sm"
        color="sysColorWarningAlt"
        className="icon"
        aria-hidden="true"
      />
      <BodyText>
        <Message
          id={id}
          button={(innerMessage) => (
            <Button tertiary onClick={handleRetry}>
              {innerMessage}
            </Button>
          )}
        />
      </BodyText>
    </div>
  );
};

GenericInternalServiceError.propTypes = {
  handleRetry: PropTypes.func,
  id: PropTypes.string,
};
export default GenericInternalServiceError;
